import {Values} from "@wix/devzai-utils-common";

export const BymoPageMediaMaskingStandardShape = {
    Circle: 'Circle',
    Square: 'Square',
} as const;

export type BymoPageMediaMaskingStandardShape = Values<typeof BymoPageMediaMaskingStandardShape>;

export const BymoPageMediaMaskingSvgShape = {
    CloverBold: 'CloverBold',
    CloverRounded: 'CloverRounded',
    ZigzagSquare: 'ZigzagSquare',
    // This is the first masking shape that existed in a layout.
    // The SVG is not square, but I kept it as is to not affect the existing users.
    CloudBold: 'CloudBold',
    SquareBold: 'SquareBold',
    WaveSquare: 'WaveSquare',
    BlobFusion: 'BlobFusion',
    ButterflyBold: 'ButterflyBold',
    CloudPebbled: 'CloudPebbled',
    CloverSplit: 'CloverSplit',
    SquareNotchLeft: 'SquareNotchLeft',
    SquareNotchRight: 'SquareNotchRight',
    SquareTiltedCut: 'SquareTiltedCut',
    StarCutBold: 'StarCutBold',
    ZigzagStacked: 'ZigzagStacked',
} as const;

export type BymoPageMediaMaskingSvgShape = Values<typeof BymoPageMediaMaskingSvgShape>;

export const BymoPageMediaMaskingShape = {
    ...BymoPageMediaMaskingSvgShape,
    ...BymoPageMediaMaskingStandardShape
}

export type BymoPageMediaMaskingShape = Values<typeof BymoPageMediaMaskingShape>;

export function bymoPageMediaMaskingShapeIsPremium (bymoPageMediaMaskingShape: BymoPageMediaMaskingShape) {
    switch (bymoPageMediaMaskingShape) {
        case BymoPageMediaMaskingShape.Square:
        case BymoPageMediaMaskingShape.Circle: {
            return false;
        }
        default: {
            return true;
        }
    }
}



